export default {
	project_name: 'Academia Pintuco',
	company_agency: 'Empresa / Loja',
	no_company_agency_found: "Empresa / Loja no encontrada",
	add_new_company: "Adicionar nova empresa",
	state: 'Dpto/Prov/Est',
	profession: 'Perfil'
}
